<msi-modal>
    <msi-modal-header>
        <h5 style="display: flex">
            <div class="icon-container"><msi-icon name="ic_error" [size]=25></msi-icon></div>
            Confirm the remote session logout
        </h5>
    </msi-modal-header>
    <msi-modal-content>
        A remote session is currently managing the live call.
        <div class="caution-message-container">
            Caution: Continuing will log out the other session and switch the call to recovery mode!
        </div>
    </msi-modal-content>
    <msi-modal-actions align="end">
        <button class="msi-btn msi-btn-action" (click)="logoutCurrentSession()">Cancel and exit</button>
        <button id="signout" class="msi-btn" (click)="confirmLogout()">Confirm and sign in</button>
    </msi-modal-actions>
</msi-modal>
